"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  Makes an entity stale in the cache
 */
function invalidateEntity(id) {
    return {
        type: "InvalidateEntity",
        id: id
    };
}
exports.invalidateEntity = invalidateEntity;
/**
 *  Makes a field stale in the cache
 */
function invalidateField(id, fieldName) {
    return {
        type: "InvalidateField",
        id: id,
        fieldName: fieldName
    };
}
exports.invalidateField = invalidateField;
/**
 * Create a new entity
 */
function createEntity(id, newValue) {
    // tslint:disable-next-line:no-any
    return { type: "CreateEntity", id: id, newValue: newValue };
}
exports.createEntity = createEntity;
/**
 * Deletes an existing entity
 */
function deleteEntity(id) {
    return { type: "DeleteEntity", id: id };
}
exports.deleteEntity = deleteEntity;
/**
 * Update a simple field value like a string or boolean
 */
function updateField(id, fieldName, newValue) {
    return { type: "UpdateField", id: id, fieldName: fieldName, newValue: newValue };
}
exports.updateField = updateField;
/**
 * Inserts an element into an array-field in an entity
 */
function insertElement(id, fieldName, index, newValue) {
    return { type: "InsertElement", id: id, fieldName: fieldName, index: index, newValue: newValue };
}
exports.insertElement = insertElement;
/**
 * Remove an element from an array-field in an entity
 */
function removeElement(id, fieldName, index) {
    return { type: "RemoveElement", id: id, fieldName: fieldName, index: index };
}
exports.removeElement = removeElement;
/**
 * Remove all occurances of elements with specified ID from an array-field in an entity
 */
function removeEntityElement(id, fieldName, entityId) {
    return { type: "RemoveEntityElement", id: id, fieldName: fieldName, entityId: entityId };
}
exports.removeEntityElement = removeEntityElement;
//# sourceMappingURL=cache-patch.js.map